export enum WatcherTag {
  Global = 'global',
  Initial = 'initial'
}
